import React from "react";
import { makeStyles } from "@mui/styles";
import { Helmet } from "react-helmet";
import Grid from "@mui/material/Grid";
import Header from "src/components/authentication/components/Header/Header.js";
import GridItem from "src/components/authentication/components/Grid/GridItem.js";
import Parallax from "src/components/authentication/components/Parallax/Parallax.js";

import styles from "src/components/authentication/assets/jss/labs/views/AboutPage.js";
import teamstyles from "src/components/authentication/assets/jss/labs/views/aboutPageSections/teamStyle.js";

import ProductSection from "./Sections/ProductSection.js";

import { SocialIcon } from "react-social-icons";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const dashboardRoutes = [];

const useStyles = makeStyles(styles);
const teamuseStyles = makeStyles(teamstyles);

export default function AboutPage(props) {
  const classes = useStyles();
  const teamclasses = teamuseStyles();
  const { ...rest } = props;

  const { color, fixed, absolute, page, navigation } = props;

  return (
    <div>
      <Helmet>
        <title>LabAsService</title>
      </Helmet>
      <Header
        color="transparent"
        routes={dashboardRoutes}
        brand="LabAsService"
        page="Back"
        navigation="app/dashboard"
        fixed
        changeColorOnScroll={{
          height: 200,
          color: "white",
        }}
        {...rest}
      />

      <Parallax
        filter
        image={
          require("src/components/authentication/assets/img/landing-bg.jpg")
            .default
        }
      >
        <Grid container spacing={3}>
          <Grid item lg={6} sm={6} xl={6} xs={6} className={classes.container}>
            <div
              className={classes.container}
              style={{ padding: "20px 0", textAlign: "-webkit-center" }}
            >
              <GridItem xs={12} sm={12} md={6}>
                <div
                  style={{
                    display: "block",
                    paddingTop: "30px",
                  }}
                >
                  <Grid xs={12} sm={12} md={8}>
                    <br />
                    <img
                      alt="..."
                      src={require("src/assets/img/labasservice1.png").default}
                    />
                  </Grid>
                  <h1 className={classes.title}>ZippyOPS</h1>
                  <h4>Making Automation Work</h4>

                  <br />

                  <Box component={Typography} variant="body1" sx={{ mb: 2 }}>
                    <SocialIcon
                      target="blank"
                      url="https://twitter.com/ZippyOps"
                      network="twitter"
                      fgColor="#fff"
                      style={{ height: 35, width: 35 }}
                    />
                    <SocialIcon
                      target="blank"
                      url="https://facebook.com/zippyops"
                      network="facebook"
                      fgColor="#fff"
                      style={{ marginLeft: "0.5em", height: 35, width: 35 }}
                    />
                    <SocialIcon
                      target="blank"
                      url="https://instagram.com/zippyops"
                      network="instagram"
                      fgColor="#fff"
                      style={{ marginLeft: "0.5em", height: 35, width: 35 }}
                    />
                    <SocialIcon
                      target="blank"
                      url="https://youtube.com/channel/UCZh2aijMM-h6ztRo36m3CiQ"
                      network="youtube"
                      fgColor="#fff"
                      style={{ marginLeft: "0.5em", height: 35, width: 35 }}
                    />
                    <SocialIcon
                      target="blank"
                      url="https://linkedin.com/in/zippyops"
                      network="linkedin"
                      fgColor="#fff"
                      style={{ marginLeft: "0.5em", height: 35, width: 35 }}
                    />
                    <SocialIcon
                      target="blank"
                      url="https://t.me/ZippyOPS"
                      network="telegram"
                      fgColor="#fff"
                      style={{ marginLeft: "0.5em", height: 35, width: 35 }}
                    />
                  </Box>
                </div>
                <br />
              </GridItem>
            </div>
          </Grid>
          <Grid item lg={6} sm={6} xl={6} xs={6} className={classes.container}>
            <ProductSection />
          </Grid>
        </Grid>
      </Parallax>
    </div>
  );
}
